export function InfoRow({
  label,
  value,
}: {
  label: string;
  value: string | number;
}) {
  return (
    <div className="flex items-center justify-between py-2 border-b border-[#F0F0F2] last:border-0">
      <span className="text-sm text-gray-500">{label}</span>
      <span
        className="text-sm font-medium text-gray-900 max-w-[60%] truncate text-right"
        title={String(value)}
      >
        {value}
      </span>
    </div>
  );
}
